const facet = () => {

    (function ($) {

        const resetFilter = document.querySelector('#reset_facet_filters');

        if (resetFilter) {
            resetFilter.addEventListener('click', function () {
                const search = document.querySelector('.facetwp-search');
                if (search) search.value = '';
                const topics = document.querySelector('.facetwp-facet-topics select');
                if (topics) topics.selectedIndex = 0;
                const categories = document.querySelector('.facetwp-facet-categories select');
                if (categories) categories.selectedIndex = 0;
                const authors = document.querySelector('.facetwp-facet-author select');
                if (authors) authors.selectedIndex = 0;
                FWP.refresh();
            });
        }

        $(document).on('facetwp-refresh', function () {
            if (FWP.soft_refresh == true) {
                FWP.enable_scroll = true;
            } else {
                FWP.enable_scroll = false;
            }
        });

        $(document).on('facetwp-loaded', function () {

            // console.log(FWP);

            FWP.facetGridElTop = document.querySelector('.c-hero').getBoundingClientRect().height
            if (FWP.enable_scroll == true) {
                $('html, body').animate({ scrollTop: FWP.facetGridElTop }, 500);
            }

            if (resetFilter) {
                resetFilter.style.display = 'flex';
                if (FWP.facets.categories.length == 0 && FWP.facets.topics.length == 0 & FWP.facets.author.length == 0) {
                    resetFilter.style.display = 'none';
                }
            }

            const top_pagination = document.querySelector('.top_pagination');
            if (FWP.settings.pager.page > 1) {
                top_pagination.style.display = 'block';
            } else {
                top_pagination.style.display = 'none';
            }

        });
    })(jQuery);
}

facet()